import React from "react";

export default function FreeTrialCard() {
  return (
    <div className="bg-dry py-0 sm:py-32">
      <div className="max-w-6xl mx-auto bg-black rounded-2xl overflow-hidden flex flex-col md:flex-row">
        {/* Left Image */}
        <div className="flex-1">
          <img
            src="https://images.pexels.com/photos/1654834/pexels-photo-1654834.jpeg"
            alt="Free Trial"
            className="w-full h-full object-cover grayscale"
          />
        </div>

        {/* Right Text Block */}
        <div className="flex-1 bg-black text-white p-10 flex flex-col justify-center">
          <h2 className="text-4xl font-semibold leading-snug mb-6">
            Try Lokalai free <br /> for 30 days
          </h2>
          <p className="text-lg mb-8">
            Start automating your bookings, loyalty, and marketing today. No
            credit card required. Full access. Cancel anytime — risk free!
          </p>
          <div className="flex items-center gap-4">
            <button className="bg-redlight hover:text-reddark text-white font-semibold py-3 px-6 rounded-full transition">
              Start your free trial
            </button>
            <button className="font-semibold border-b border-white hover:opacity-80 transition">
              Talk to us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
